module.exports = __webpack_public_path__ + "static/media/shookit.19ad55fa.png";